import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { getOrder, updateOrder } from '../../order'
import { disableStep, enableStep, getStep, nextStep } from '../../steps'
import Button from '../../../../ui/Button'
import Form from './shipping/Form'
import ImmutablePropTypes from 'react-immutable-proptypes'
import LazyLoadingLocations from './shipping/LazyLoadingLocations'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Sticky from 'react-stickynode'
import styles from './css/Shipping.scss'
import ValidationErrors from '../../components/ValidationErrors'
import { withRouter } from 'react-router-dom'
import { selectAdditions } from '../../../app/additions'
import Alert from '../../../../ui/Alert'

export class ShippingStep extends Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        additions: ImmutablePropTypes.list,
        order: ImmutablePropTypes.map.isRequired,
        step: ImmutablePropTypes.map.isRequired,
    }

    componentWillMount () {
        const { dispatch, additions } = this.props
        window.scrollTo(0, 0)
        // Enable additions as next step conditionally
        dispatch(additions && additions.size > 0 ? enableStep('additions') : disableStep('additions'))
    }

    handleNextStep = () => {
        const { dispatch, step } = this.props
        dispatch(nextStep(step))
    }

    handleLocationSelect = (e, location) => {
        const { order, dispatch } = this.props
        let newOrder

        if (order.get('location') !== location.get('id')) {
            newOrder = order.set('location', location.get('id'))
        } else {
            newOrder = order.set('location', null)
        }

        dispatch(updateOrder(newOrder))
    }

    renderErrorMessage () {
        const { step } = this.props
        const errorMessageSlug = step.get('errormessage')
        return !errorMessageSlug ? (
            <ValidationErrors
                errors={step.get('errors')}
                status={step.get('state')}
            >
                <FormattedMessage id="frontend.form_selector_shipping.validation"/>
            </ValidationErrors>
        ) : (
            <Alert type="warning">
                {errorMessageSlug}
            </Alert>
        )
    }

    render () {
        const { order } = this.props
        const shipToNewAddress = order.get('shipToNewAddress')

        if (shipToNewAddress) {
            return (
                <div>
                    <Form/>
                </div>
            )
        } else {
            return (
                <div>
                    <Sticky
                        top="#page-header"
                        innerZ={98}
                    >
                        <div className={styles.container}>
                            <h2 className={styles.headline}>
                                <FormattedMessage
                                    id="frontend.form_selector_shipping.headline.intro"
                                />
                            </h2>
                            <Button
                                block
                                disabled={!order.get('location')}
                                emphasis="primary"
                                className={styles.handleNext}
                                onClick={this.handleNextStep}
                            >
                                <FormattedMessage id="frontend.form_selector_shipping.button.continue"/>
                            </Button>
                        </div>

                        {this.renderErrorMessage()}
                    </Sticky>
                    <LazyLoadingLocations onSelect={this.handleLocationSelect} />
                    <Form/>
                </div>
            )
        }
    }
}

export default withRouter(connect(state => ({
    order: getOrder(state),
    additions: selectAdditions(state),
    step: getStep(state, 'shipping'),
}))(ShippingStep))
